/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenInfoDto } from '../../models/token-info-dto';

export interface TokenControllerGetTokenInfo$Params {
  centerId: string;
}

export function tokenControllerGetTokenInfo(http: HttpClient, rootUrl: string, params: TokenControllerGetTokenInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenInfoDto>> {
  const rb = new RequestBuilder(rootUrl, tokenControllerGetTokenInfo.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenInfoDto>;
    })
  );
}

tokenControllerGetTokenInfo.PATH = '/api/token';
